import moment from "moment";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CalendarIcon from "@iconify/icons-mdi/calendar-expand-horizontal";
import ChevronLeft from "@iconify/icons-mdi/chevron-left";
import ChevronRight from "@iconify/icons-mdi/chevron-right";
import { InlineIcon } from "@iconify/react";
import { PeriodType } from "my-timesheet/types/period-type";

interface MyRequestsDashboardDateRangeNavigationProps {
  iconSize: number;
  isMobile: boolean;
  currentDate: Date;
  period: PeriodType;
  onChangeCurrentDate: (date: Date) => void;
}

export const MyTimesheetMyRequestsDashboardDateRangeNavigation = ({
  iconSize,
  isMobile,
  currentDate,
  period,
  onChangeCurrentDate,
}: MyRequestsDashboardDateRangeNavigationProps) => {
  const theme = useTheme();

  const isLastPeriod = moment(currentDate).isSame(moment(), period);

  const formattedSate =
    period === "month"
      ? moment(currentDate).format("YYYY. MMMM")
      : `${moment(currentDate).startOf("week").format("MMMM DD.")} - ${moment(
          currentDate,
        )
          .endOf("week")
          .format("MMMM DD.")}`;

  const borderedBoxStyle = {
    border: `1px solid ${theme.palette.gray60.main}`,
    borderRadius: "4px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: "36px",
    cursor: "pointer",
  };

  const handleCurrentDateChange = (direction: "NEXT" | "PREV") => {
    if (isLastPeriod && direction === "NEXT") {
      return;
    }
    if (direction === "NEXT") {
      onChangeCurrentDate(moment(currentDate).add(1, period).toDate());
    } else if (direction === "PREV") {
      onChangeCurrentDate(moment(currentDate).subtract(1, period).toDate());
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      width={isMobile ? "100%" : "auto"}
    >
      <Box sx={borderedBoxStyle} width="36px">
        <InlineIcon
          id="PREV"
          icon={ChevronLeft}
          width={iconSize}
          height={iconSize}
          color={theme.palette.gray60.main}
          onClick={() => handleCurrentDateChange("PREV")}
        />
      </Box>
      <Box width="8px" />
      <Box sx={borderedBoxStyle} width="360px">
        <InlineIcon
          icon={CalendarIcon}
          width={iconSize}
          height={iconSize}
          color={theme.palette.gray60.main}
        />
        <Box width="10px" />
        <Typography variant="h6" style={{ color: theme.palette.gray80.main }}>
          {formattedSate}
        </Typography>
      </Box>
      <Box width="8px" />
      <Box sx={borderedBoxStyle} width="36px">
        <InlineIcon
          id="NEXT"
          icon={ChevronRight}
          width={iconSize}
          height={iconSize}
          color={
            isLastPeriod ? theme.palette.gray40.main : theme.palette.gray60.main
          }
          onClick={() => handleCurrentDateChange("NEXT")}
        />
      </Box>
    </Box>
  );
};

export default MyTimesheetMyRequestsDashboardDateRangeNavigation;
